import axios, { AxiosInstance } from 'axios';
import { apiMailingURL, mockAndDevelopment } from '../../app.config';

const mailingClient: AxiosInstance = mockAndDevelopment()
  ? axios.create()
  : axios.create({
      baseURL: apiMailingURL(),
      headers: {
        accept: '*/*',
        contentType: 'application/json',
      },
      paramsSerializer: {
        indexes: null,
      },
    });

export default mailingClient;
